package app.nestbridge.feature.careteam.usecase

import app.nestbridge.feature.careteam.model.CareTeam
import app.nestbridge.feature.careteam.service.CareTeamService
import me.tatarka.inject.annotations.Inject

@Inject
class SaveCareTeamUseCase(
    private val careTeamService: CareTeamService,
) {
    suspend operator fun invoke(careTeam: CareTeam): CareTeam = careTeamService.save(careTeam)
}
